import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

/**
 * For empty selections, the start and end will be the same
 */

/** A context from analytics. */

/**
 * type guard to detect if the initial context is for range selection
 * based on selection prop availability
 */
export function isInitialContextSelectionRange(value) {
  return 'selection' in value && typeof value.selection === 'string';
}

/**
 * `EditorPluginAIConfigItem`s are used by EditorPluginAI
 * to provide AI experiences.
 *
 * **This type is not inteded to be used directly by consumers**
 * when building config items. For creating objects which conform
 * to this type:
 * @see {@link createEditorPluginAIConfigItem}
 *
 */

/**
 * This creates a new EditorPluginAI config item (`EditorPluginAIConfigItem`)
 * for use when setting up an editorPluginAI.
 *
 * @example
 * ```tsx
 * const configItem = createEditorPluginAIConfigItem({...})
 * const editorPluginAI = new EditorPluginAI({
 *   configItems: [configItem],
 *   editorPluginAIProvider,
 * })
 * ```
 */
// Creating via a function like this helps with type inference
export function createEditorPluginAIConfigItemMarkdown(editorPluginAIConfigItem) {
  return editorPluginAIConfigItem;
}
export function getTranslatedItemTitle(configItem, formatMessage) {
  // for agents return the saved agent name in the same language as it was saved
  if (configItem.agent) {
    var presetTitle = "".concat(editorExperiment('platform_editor_ai_command_palate_improvement', 'test') ? '@' : '').concat(configItem.agent.name);
    return presetTitle || formatMessage(configItem.title);
  }

  // adding beta label for the translation prompts
  if (configItem.key.startsWith('Translate to')) {
    return formatMessage(configItem.title);
  }

  // for all other items return the i18n-ed title
  return formatMessage(configItem.title);
}

/**
 * use this function get the translated prompt label in the ui components
 */
export function getTranslatedPromptLabel(configItem, formatMessage) {
  if (configItem.agent) {
    // for agents return the saved agent name in the same language as it was saved
    if (editorExperiment('platform_editor_ai_command_palate_improvement', 'test')) {
      return "@".concat(configItem.agent.name);
    } else {
      return configItem.agent.name;
    }
  }

  // intentionally fall back to undefined as this value is checked to verify if we need to show the prompt input
  return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
}